export default {
  svgPath: `
    <path d="M16.5002 9.91421L11.0002 4.41421V19H9.00015L9.00015 4.41421L3.50015 9.91421L2.08594 8.5L9.29304 1.29289C9.68357 0.902369 10.3167 0.902369 10.7073 1.29289L17.9144 8.5L16.5002 9.91421Z" fill="currentColor"/>
  `,
  title: 'Arrow Up',
  viewBox: '0 0 20 20',
};
